import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AccessGuard } from '@services/auth/access.guard';
import { AuthGuard } from '@services/auth/auth.guard';
import { AccessDeniedComponent } from './shared/error-pages/access-denied/access-denied.component';
import { InternalServerErrorComponent } from './shared/error-pages/internal-server-error/internal-server-error.component';
import { LoggedOutComponent } from './shared/error-pages/logged-out/logged-out.component';
import { PageNotFoundComponent } from './shared/error-pages/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
    pathMatch: 'full',
    canActivate: [MsalGuard, AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [MsalGuard, AuthGuard]
  },
  {
    path: 'batches',
    loadChildren: () => import('./features/batches/batches.module').then(m => m.BatchesModule),
    canActivate: [MsalGuard, AuthGuard],
    data: { breadcrumb: 'Batches' }
  },
  {
    path: 'haulers',
    loadChildren: () => import('./features/haulers/haulers.module').then(m => m.HaulersModule),
    canActivate: [MsalGuard, AuthGuard],
    data: { breadcrumb: 'Hauler Management' }
  },
  {
    path: 'profile',
    loadChildren: () => import('./features/my-profile/my-profile.module').then(m => m.MyProfileModule),
    canActivate: [MsalGuard, AuthGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [MsalGuard, AuthGuard]
  },
  {
    path: 'invoices',
    loadChildren: () => import('./features/invoices/invoices.module').then(m => m.InvoicesModule),
    canActivate: [MsalGuard, AuthGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule),
    canActivate: [MsalGuard, AuthGuard],
    data: { breadcrumb: 'Admin' }
  },
  {
    path: 'company',
    loadChildren: () => import('./features/company-profile/company-profile.module').then(m => m.CompanyProfileModule),
    canActivate: [MsalGuard, AuthGuard],
    data: { breadcrumb: 'Company Profile' }
  },

  {
    path: 'support',
    loadChildren: () => import('./features/support/support.module').then(m => m.SupportModule),
    canActivate: [MsalGuard, AuthGuard]
  },
  {
    path: 'register',
    loadChildren: () => import('./features/registration/registration.module').then(m => m.RegistrationModule),
    canActivate: [MsalGuard, AccessGuard]
  },
  {
    path: '',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule),
    canActivate: [MsalGuard, AuthGuard]
  },
  { path: 'internal-server-error', component: InternalServerErrorComponent },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: 'logged-out', component: LoggedOutComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard, AccessGuard]
})
export class AppRoutingModule {}
